// extracted by mini-css-extract-plugin
export default {"home":"Home_home__9Gj9b","body":"Home_body__0uw+4"};